(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/react/components/start-header.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/react/components/start-header.js');

'use strict';

const StartHeader = () => {
  const dreamWin = svs.lotto.data.jackpots.find(item => item.winset === 2);
  const jackpotText = (dreamWin === null || dreamWin === void 0 ? void 0 : dreamWin.defaultJackpot) === true ? dreamWin.guaranteedJackpotAmountString : dreamWin.jackpotAmountStringShort;
  return React.createElement("h1", {
    className: "start-header"
  }, "Dr\xF6mvinsten\xA0", React.createElement("span", null, jackpotText));
};
setGlobal('svs.lotto.react.components', {
  StartHeader
});

 })(window);